import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class CaseFilesService {

    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    uploadCaseFiles(caseId: string, files: File[]): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.uploadCaseFiles.replace(':caseId', caseId);
        const formData = new FormData();
        files.forEach(file => formData.append('files', file, file.name));
        return this.http.post(url, formData).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    getCaseFiles(caseId: string): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.getCaseFiles.replace(':caseId', caseId);
        return this.http.get(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    downloadCaseFile(caseId: string, fileId: number): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.downloadCaseFile.replace(':caseId', caseId).replace(':fileId', String(fileId));
        return this.http.get(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}
